import { AxiosInstance } from 'axios'
import { BlocksContent } from '@strapi/blocks-react-renderer'
import {
  BeforeAfterItem,
  ContentDescriptionBlock,
  Localizations,
  MediaObject,
  PriceItem,
} from '@/shared/api/strapi/requests/types'

export type ServiceDto = {
  id: string
  attributes: {
    faq: ContentDescriptionBlock[]
    introduction_list: ContentDescriptionBlock[]
    localizations: Localizations
    before_after_text: BlocksContent
    before_afters: { data: BeforeAfterItem[] }
    contraindications: BlocksContent
    description: BlocksContent
    image: MediaObject
    indications: BlocksContent
    introduction_text: BlocksContent
    introduction_title: string
    name: string
    on_site: boolean
    prices?: PriceItem[]
    specialists?: Specialists
    steps?: StepItem[]
    steps_title?: string
    youtube_link?: string
  }
}

export type Specialists = {
  data: SpecialistItem[]
}

export type SpecialistItem = {
  attributes: {
    name: string
    academic_degree?: string
    photo?: MediaObject
    slug: string
    specialties: {
      data: SpecialtiesItem[]
    }
  }
  id: number
}

export type SpecialtiesItem = {
  attributes: {
    name: string
  }
  id: number
}

export type StepItem = {
  id: number
  title: string
  description: BlocksContent
}

export interface GetServiceArgs {
  locale: string
  slug: string
}

export const getService = async (client: AxiosInstance, { locale, slug }: GetServiceArgs) => {
  const path = `/services`
  const params = {
    locale,
    fields: [
      'before_after_text',
      'contraindications',
      'description',
      'indications',
      'introduction_text',
      'introduction_title',
      'name',
      'on_site',
      'steps_title',
      'youtube_link',
    ],
    populate: {
      introduction_list: {
        fields: ['title', 'description'],
      },
      faq: {
        fields: ['id', 'title', 'description'],
      },
      localizations: {
        fields: ['locale', 'slug'],
      },
      before_afters: { populate: '*' },
      image: { populate: '*' },
      prices: { populate: '*' },
      specialists: {
        fields: ['name', 'slug', 'academic_degree'],
        populate: {
          specialties: {
            populate: {
              fields: ['name'],
            },
          },
          photo: {
            populate: '*',
          },
        },
      },
      steps: { populate: '*' },
    },
    filters: {
      slug: {
        $eq: slug,
      },
    },
  }

  return (await client.get<{ data: ServiceDto[] }>(path, { params })).data.data[0]
}
